import classNames from 'classnames/bind';
import * as R from 'ramda';
import React from 'react';
import { ReduxTypeUtils } from 'utils/ReduxTypeUtils';

import { connectFormikContext } from 'reactComponents/Forms/ConnectFormikContext';
import { Message } from 'reactComponents/Message/Message';

import styles from './FieldCommonErrorMessages.css';

const css = classNames.bind(styles);

type OwnProps = { className?: string };

type KnownValues = {
    commonErrorMessages?: string[];
};

const contextConnector = connectFormikContext<OwnProps, KnownValues>();

type Props = OwnProps & ReduxTypeUtils.TypeOfConnector<typeof contextConnector>;

const _FieldCommonErrorMessagesComponent = (props: Props) => {
    const commonErrorMessages: string[] = R.pathOr(
        [],
        ['errors', 'commonErrorMessages'],
        props._formikContext,
    );

    if (!commonErrorMessages.length) {
        return null;
    }
    return (
        <Message icon="warning" className={css('root', props.className)}>
            {commonErrorMessages.map((errorHtml, index) => (
                <div
                    className={css('text')}
                    dangerouslySetInnerHTML={{ __html: errorHtml }}
                    key={index}
                />
            ))}
        </Message>
    );
};

export const FieldCommonErrorMessages = contextConnector(
    _FieldCommonErrorMessagesComponent,
);
